export {
  PRACTICE_SESSION_USAGE_MODES,
  SUBSCRIPTION_STATUSES,
  VALID_PLANS,
  VALID_PLANS as ORG_PLANS,
} from '@akoreps/billing-config';

export type {
  Plan as OrgPlan,
  Plan,
  PracticeSessionUsageMode,
  SubscriptionStatus,
} from '@akoreps/billing-config';

export function planDisplayName(plan: string): string {
  if (!plan) return '—';
  return plan.charAt(0).toUpperCase() + plan.slice(1);
}

export function toDatetimeLocalValue(iso: string | null | undefined): string {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

/** Returns ISO string or null if empty/invalid. */
export function fromDatetimeLocalValue(local: string): string | null {
  const t = local.trim();
  if (!t) return null;
  const d = new Date(t);
  return Number.isNaN(d.getTime()) ? null : d.toISOString();
}
